import Vue from 'vue'
import VueRouter from 'vue-router'
// import Home from '../views/Home.vue'
import firebase from 'firebase/app'

Vue.use(VueRouter)

const routes = [
  // {
  //   path: '/',
  //   name: 'Home',
  //   component: Home
  // },
   {
    path: '/login',
    name: 'login',
    meta: {layout: 'empty'},
    component: () => import( '../views/Login.vue')
  },
   {
    path: '/register',
    name: 'register',
    meta: {layout: 'empty'},
    component: () => import( '../views/Register.vue')
  },
  {
    path: '/',
    name: 'home',
    meta: {layout: 'main', auth: true},
    component: () => import( '../views/Home.vue')
  },
  {
    path: '/categories',
    name: 'categories',
    meta: {layout: 'main', auth: true},
    component: () => import( '../views/Categories.vue')
  },
   {
    path: '/detail/:id',
    name: 'detail',
    meta: {layout: 'main', auth: true},
    component: () => import( '../views/Detail.vue')
  },
  {
    path: '/history',
    name: 'history',
    meta: {layout: 'main', auth: true},
    component: () => import( '../views/History.vue')
  },
    
    {
    path: '/planning',
    name: 'planning',
    meta: {layout: 'main', auth: true},
    component: () => import( '../views/Planning.vue')
  },
   {
    path: '/profile',
    name: 'profile',
    meta: {layout: 'main', auth: true},
    component: () => import( '../views/Profile.vue')
  },
   {
    path: '/record',
    name: 'record',
    meta: {layout: 'main', auth: true},
    component: () => import( '../views/Record.vue')
  },
   

  // {
  //   path: '/about',
  //   name: 'About',
     
  //   component: () => import( '../views/About.vue')
  // }
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

 
// метод beforeEach будет вызываться перед каждой сменой роута, здесь можно проверять на наличие авторизации
// ту куда фром откуда некст что делать дальше
router.beforeEach((to, from, next) => {
 const currentUser = firebase.auth().currentUser
 const requireAuth = to.matched.some(record => record.meta.auth)

 if (requireAuth && !currentUser) {
next('/login?message=login')
}else {
  next()
}

})

//обр к методу аутс и забрали поле карент юзер если данные есть пользователь в ситеме
export default router